import styled from 'styled-components'

export const Separator = styled.div`
    display: block;
    height: 1px;
    border-top: ${(p) => `1px solid ${p.theme.colors.lighterGrey}`};
    padding: 0;
    margin-bottom: 0.5em;
    box-sizing: border-box;
`

export const VerticalSeparator = styled.div`
    border-right: ${(p) => `1px solid ${p.theme.colors.lighterGrey}`};
`
